/*
 * Gratis-verzending voortgang in de announcement bar.
 * Plain IIFE (geen ES-module imports / custom elements) voor maximale
 * robuustheid: hookt fetch/XHR op cart-mutaties + leest /cart.js, en zet de
 * class `announcement-bar--cart-active` op .announcement-bar zodra er items in
 * de winkelwagen zitten. De CSS regelt de zichtbaarheid (Horizon-styling blijft).
 */
(function () {
  function euro(cents) {
    var v = (Math.round(cents) / 100).toFixed(2).split('.');
    return '€' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
  }

  function roots() {
    return document.querySelectorAll('free-shipping-announcement');
  }

  /** @param {{item_count:number,total_price:number}|null} cart */
  function update(cart) {
    roots().forEach(function (root) {
      var bar = root.closest('.announcement-bar');
      var itemCount = cart ? cart.item_count : parseInt(root.dataset.cartCount || '0', 10) || 0;
      var total = cart ? cart.total_price : parseInt(root.dataset.cartTotal || '0', 10) || 0;
      var threshold = parseInt(root.dataset.thresholdCents || '0', 10) || 0;

      // Houd de dataset in sync zodat een latere update zonder payload klopt.
      root.dataset.cartCount = String(itemCount);
      root.dataset.cartTotal = String(total);

      if (bar) bar.classList.toggle('announcement-bar--cart-active', itemCount > 0 && threshold > 0);

      if (threshold <= 0) return;

      var textEl = root.querySelector('.fs-announcement__text');
      var track = root.querySelector('.fs-announcement__bar');
      var fill = root.querySelector('.fs-announcement__bar-fill');
      if (!textEl) return;

      var remaining = Math.max(threshold - total, 0);
      var reached = remaining === 0;
      var progress = Math.min(Math.round((total / threshold) * 100), 100);
      var showProgress = root.dataset.showProgress !== 'false';

      if (reached) {
        textEl.textContent = root.dataset.successMessage || 'Je hebt gratis verzending!';
        if (track) track.classList.add('fs-announcement__bar--hidden');
        return;
      }

      var before = root.dataset.messageBefore || 'Nog ';
      var after = root.dataset.messageAfter || ' tot gratis verzending';
      var amount = document.createElement('span');
      amount.className = 'fs-announcement__amount';
      amount.textContent = euro(remaining);
      textEl.replaceChildren(document.createTextNode(before), amount, document.createTextNode(after));

      if (showProgress && track && fill) {
        track.classList.remove('fs-announcement__bar--hidden');
        fill.style.width = progress + '%';
        track.setAttribute('aria-valuenow', String(progress));
      }
    });
  }

  var fetching = false;
  function fetchCart() {
    if (fetching) return;
    fetching = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) update(cart); })
      .catch(function () {})
      .then(function () { fetching = false; });
  }

  var CART_RE = /\/cart\/(add|change|update|clear)/;

  // Hook fetch (Horizon + de meeste apps muteren de cart via fetch).
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function () {
      var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
      var result = origFetch.apply(this, arguments);
      if (CART_RE.test(url)) result.then(function () { setTimeout(fetchCart, 60); }, function () {});
      return result;
    };
  }

  // Hook XHR (fallback voor oudere app-integraties).
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && CART_RE.test(url)) {
      this.addEventListener('load', function () { setTimeout(fetchCart, 60); });
    }
    return origOpen.apply(this, arguments);
  };

  // Horizon dispatcht ook cart-events; luister breed voor de zekerheid.
  ['cart:update', 'cart-update', 'cart:refresh', 'variant:add'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(fetchCart, 60); });
  });

  // Direct op basis van de server-gerenderde data, daarna verse cart ophalen.
  update(null);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchCart);
  } else {
    fetchCart();
  }
})();
